import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CountToModule } from 'angular-count-to';
import { AngularTiltModule } from 'angular-tilt';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { LoaderComponent } from './components/loader/loader.component';
import { MenuComponent } from './components/navigation/menu/menu.component';
import { NavComponent } from './components/pages/app-menu/nav.component';
import { FooterComponent } from './components/pages/footer/footer.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
import { StudiesComponent } from './components/studies/studies.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { AgencyConstructionComponent } from './components/construction/construction.component';
import { ServiceCounterComponent } from './components/counter/counter.component';
import { ServiceImgComponent } from './components/service-img/service-img.component';
import { LeaveRequestComponent } from './components/leave-request/request.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { ServicesComponent } from './components/services/services.component';
import { JoinUsComponent } from './components/join-us/join-us.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MenuComponent, NavComponent, TapToTopComponent, FooterComponent, LoaderComponent, StudiesComponent, AgencyConstructionComponent, ServiceCounterComponent, ServiceImgComponent, LeaveRequestComponent, ServicesComponent, JoinUsComponent],
  exports: [
    MenuComponent,
    NavComponent,
    LoaderComponent,
    FooterComponent,
    TapToTopComponent,
    StudiesComponent,
    AgencyConstructionComponent,
    ServiceImgComponent,
    ServiceCounterComponent,
    LeaveRequestComponent,
    ServicesComponent,
    JoinUsComponent,
    TranslateModule
  ],
  imports: [
    CommonModule,
    ScrollToModule,
    CountToModule,
    CarouselModule,
    RecaptchaModule,
    AngularTiltModule,
    MatButtonToggleModule,
    MatInputModule,
    MatIconModule,
    MatStepperModule,
    RecaptchaFormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    ToastrModule.forRoot()
  ],
  providers: [
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'en',
    }
  ],
})
export class SharedModule { }
